import { AttFile } from '@/components/News/types';
import { SmallTit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC } from 'react';
import styled from 'styled-components';

interface FileProps {
  files: AttFile[];
}

const FileBox = styled.dl`
  background: #f8f9fa;
  padding: 32px;

  ${breakpoint(`tablet`)} {
    padding: 16px;
  }
`;
const FileList = styled.ul`
  margin-top: 14px;

  li {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const FileContainer: FC<FileProps> = ({ files }) => (
  <FileBox>
    <dt>
      <SmallTit>첨부파일</SmallTit>
    </dt>
    <dd>
      <FileList>
        {files.map((file) => (
          <li key={file.indexNumber}>
            <a href={file.downloadUrl} download className="file-item">
              {file.dispFileNm}
            </a>
          </li>
        ))}
      </FileList>
    </dd>
  </FileBox>
);
export default FileContainer;
